export const REACT_APP_MAIL = process.env.REACT_APP_MAIL;
export const REACT_APP_PHONE = process.env.REACT_APP_PHONE;